import { DeviceConfig } from '@thingslog/repositories';

const LOCAL_STORAGE_KEY = 'preferedEveryInSeconds';

export class TranmissionPersistanceManager {
  private deviceConfig: DeviceConfig;

  public constructor(deviceConfig: DeviceConfig) {
    this.deviceConfig = deviceConfig;
  }

  public calculateTransmissionIntervalInSeconds(interval: number): number {
    const periodInSeconds = {
      SECONDS: 1,
      MINUTES: 60,
      HOURS: 3600, // 60 * 60
      DAYS: 86400, // 60 * 60 * 24
    }[this.deviceConfig.recordPeriod];

    if (periodInSeconds === undefined) {
      throw Error('Unknown record period');
    }

    return interval * this.deviceConfig.every * periodInSeconds;
  }

  public saveIntervalToLocalStorage(intervalInSeconds: number): void {
    localStorage.setItem(LOCAL_STORAGE_KEY, intervalInSeconds.toString());
  }

  public getIntervalFromLocalStorage(): number | null {
    try {
      const intervalInSeconds = localStorage.getItem(LOCAL_STORAGE_KEY);
      return intervalInSeconds ? parseInt(intervalInSeconds, 10) : null;
    } catch {
      return null;
    }
  }

  public deriveIntervalFromSeconds(targetIntervalInSeconds: number): number | null {
    const baseIntervalInSeconds = this.calculateTransmissionIntervalInSeconds(1);
    if (targetIntervalInSeconds % baseIntervalInSeconds === 0) {
      return targetIntervalInSeconds / baseIntervalInSeconds;
    }
    return null;
  }
}
